import { createAction } from '@poa/state';

export const logIn = createAction('logIn', (username, password) => ({ username, password }));
export const logInSuccess = createAction('logInSuccess', ({ accessLevel, accessHosts }) => ({
  accessLevel,
  accessHosts
}));
export const logInFailed = createAction('logInFailed', () => ({}));

export const restoreSession = createAction('restoreSession', (accessLevel, accessHosts) => ({
  accessLevel,
  accessHosts
}));
export const invalidateSession = createAction('invalidateSession', () => ({}));

export const updatePermissions = createAction(
  'updatePermissions',
  (hostname, accessLevel, accessHosts) => ({
    hostname,
    accessLevel,
    accessHosts
  })
);
